import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map } from 'rxjs';

interface NavItem {
  label: string;
  path: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'edu-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterLink],
})
export class AdminHeaderComponent {
  readonly #router = inject(Router);

  readonly activeUrl = toSignal(
    this.#router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
    ),
    { initialValue: this.#router.url },
  );

  readonly navItems: ReadonlyArray<NavItem> = [
    { label: 'Gebruikersinformatie', path: '/user' },
    { label: 'Onderhoudsmeldingen', path: '/maintenance' },
    { label: 'Methods', path: '/method' },
    { label: 'Streams', path: '/stream' },
    { label: 'Platforms', path: '/platform' },
    { label: 'Chatbot', path: '/chatbot' },
  ];

  readonly viewModel = computed(() => {
    const activeUrl = this.activeUrl();
    return {
      navItems: this.navItems.map((item) => ({
        ...item,
        active: activeUrl.startsWith(item.path),
      })),
    };
  });
}
